export const isDanish: boolean = window.location.hostname.endsWith('s.dk')
export const isCargo: boolean =
  window.location.search.includes('electric-cargo')

export const useUrlReplacers = (): void => {
  let url: string = window.location.href

  if (url.includes('kickstand=off')) {
    window.location.replace(url.replace('kickstand=off', 'kickstand=single'))
  }

  if (url.includes('saddle=black-leather')) {
    window.location.replace(
      url.replace('saddle=black-leather', 'saddle=v-black-leather')
    )
  }
  if (url.includes('saddle=brown-leather')) {
    window.location.replace(
      url.replace('saddle=brown-leather', 'saddle=v-brown-leather')
    )
  }

  if (url.includes('saddle=arrow-brown-leather')) {
    window.location.replace(url.replace('arrow-brown-leather', 'sport-brown'))
  }

  if (url.includes('saddle=black-fabric')) {
    window.location.replace(url.replace('black-fabric', 'sport-black'))
  }
}
